/** @jsx jsx */
import { useState } from 'react'
import { Box, Container, Grid, Heading, jsx } from 'theme-ui'
import useArticleListQuery from '~/hooks/graphql/queries/use-article-list'
import ArticleCard from '~/components/Article/Card'
import Dropdown from '~/components/Generic/Dropdown'
import Tabs from '~/components/Generic/Tabs'
import VisuallyHidden from '~/components/Generic/VisuallyHidden'

const ArticleListSection = ({ categories, data, title }) => {
  const { nodes } = useArticleListQuery()
  const categoryFilterOptions = [
    {
      slug: 'all',
      title: 'Latest Stories',
    },
  ]
  categories.map((category) => {
    return categoryFilterOptions.push({
      slug: category.slug,
      title: category.title,
    })
  })
  const [currentCategory, setCurrentCategory] = useState(
    categoryFilterOptions[0]
  )

  return (
    <Box bg="backgroundMedium" pt={[6, 7, 9]} pb={[6, 8, 10]}>
      <Container>
        <Box mb={[4, 5, 7]}>
          <Grid
            columns={[1, 4, 1]}
            sx={{ display: [null, null, 'none'], rowGap: '0' }}
          >
            <Box sx={{ gridColumn: [null, '2 / 4', '1 / -1'] }}>
              <VisuallyHidden>
                <Heading as="h2" variant="title3" mb={1}>
                  {'Article categories'}
                </Heading>
              </VisuallyHidden>
              <Dropdown
                ariaLabel="Article categories"
                currentOption={currentCategory}
                options={categoryFilterOptions}
                optionsLabel={'Select category'}
                setOption={setCurrentCategory}
              />
            </Box>
          </Grid>
          <Box sx={{ display: ['none', null, 'block'] }}>
            <VisuallyHidden>
              <Heading as="h2" variant="title3" mb={1}>
                {'Article categories'}
              </Heading>
            </VisuallyHidden>
            <Tabs
              ariaLabel="Article category"
              currentOption={currentCategory}
              options={categoryFilterOptions}
              setOption={setCurrentCategory}
            />
          </Box>
        </Box>
        <Grid columns={[1, 2, 3]} sx={{ rowGap: 4 }}>
          {nodes.map(
            (article, index) =>
              (currentCategory.slug === 'all' ||
                currentCategory.slug === article.category.slug) && (
                <ArticleCard key={article.slug} article={article} />
              )
          )}
        </Grid>
      </Container>
    </Box>
  )
}

export default ArticleListSection
